import { trackingStateData } from '../redux/tracking/tracking.action';
import { store } from '../redux/store';

export default function setTrackingData(dispatch : any, isMobile : any, router : any){
    const getTrackingData = store.getState().tracking
    const trackingData = {
        Device : '',
        UTM :{
            utm_source : '',
            utm_medium : '',
            utm_campaign : '',
        },
        Button : '',
        Page : ' '
    }
    // dispatch(trackingStateData(trackingData)) // clear Redux data
    trackingData.Device = isMobile ? 'Mobile' : 'Desktop'
    if(router.pathname == '/legal-consultation-b') {
        trackingData.Page = '/legal-consultation-B'
    }else{
        let final_path = router.asPath.split('?')[0]
        // trackingData.Page = router.asPath
        trackingData.Page = final_path
    }
    trackingData.UTM.utm_source =  ( router?.query?.utm_source ? router.query?.utm_source : getTrackingData?.UTM?.utm_source != undefined ? getTrackingData?.UTM?.utm_source : 'undefined' )
    trackingData.UTM.utm_medium =  ( router?.query?.utm_medium ? router.query.utm_medium : getTrackingData?.UTM?.utm_medium != undefined ? getTrackingData?.UTM?.utm_medium : 'undefined' )
    trackingData.UTM.utm_campaign = ( router?.query?.utm_campaign ? router.query.utm_campaign : getTrackingData?.UTM?.utm_campaign != undefined ? getTrackingData?.UTM?.utm_campaign : 'undefined' )
    dispatch(trackingStateData(trackingData)) //set data into redux

}
